module.exports = __webpack_public_path__ + "img/img_51@2x.8bc3995a.png";